export default __webpack_public_path__ + "static/aws-certified-cloud-practitioner-f6e731021c366ca1dcd628b7e1f5c2e9.png";